import {
  API_ERROR,
  PREFIX_CODE,
  PREFIX_CODE_LIST_SUCCESSFUL,
  SELECT_CHANGEVALUE,
  INPUT_CHANGEVALUE,
  PREFIX_CODE_ADD,
  PREFIX_CODE_ADD_SUCCESSFUL,
  PREFIX_CODE_ROW_DATA,
  PREFIX_CODE_ROW_DATA_SUCCESSFUL,
  PREFIX_CODE_DELETE,
  PREFIX_CODE_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
  SET_PARAMS,
} from "./actionTypes";

export const getPrefixCode = (data) => {
  return {
    type: PREFIX_CODE,
    payload: { data },
  };
};

export const PrefixCodeListSuccessful = (response) => {
  return {
    type: PREFIX_CODE_LIST_SUCCESSFUL,
    payload: response,
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};

export const PrefixCodeAdd = (data) => {
  return {
    type: PREFIX_CODE_ADD,
    payload: { data },
  };
};

export const PrefixCodeAddSuccessful = (response) => {
  return {
    type: PREFIX_CODE_ADD_SUCCESSFUL,
    payload: response,
  };
};

export const ItemRowData = (PreFixCodeID) => {
  return {
    type: PREFIX_CODE_ROW_DATA,
    payload: { PreFixCodeID },
  };
};

export const ItemRowDataSuccessful = (response) => {
  return {
    type: PREFIX_CODE_ROW_DATA_SUCCESSFUL,
    payload: response,
  };
};

export const PrefixCodeDelete = (PreFixCodeID) => {
  return {
    type: PREFIX_CODE_DELETE,
    payload: { PreFixCodeID },
  };
};

export const SetEditData = (data) => {
  return {
    type: PREFIX_CODE_SETROWDATA,
    payload: data,
  };
};

export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};

export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
